import { useState } from 'react'
import { Alert, Button, Collapse, IconButton } from '@mui/material'
import { Close, Security } from '@mui/icons-material'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuthStore } from '@store/authStore'
import { shouldShowStaffMfaNotice, STAFF_MFA_NOTICE, STAFF_MFA_SETUP_PATH } from '@utils/staffMfa'

// Closing the notice hides it until the tab is closed.
const DISMISS_KEY = 'staffMfaNotice.dismissed'

function readDismissed(): boolean {
  try {
    return sessionStorage.getItem(DISMISS_KEY) === '1'
  } catch {
    return false
  }
}

/** Full-width notice under the top nav for staff whose session skipped two-step sign-in. */
export function StaffMfaBanner() {
  const navigate = useNavigate()
  const location = useLocation()
  const user = useAuthStore(state => state.user)
  const isAuthenticated = useAuthStore(state => state.isAuthenticated)
  const [dismissed, setDismissed] = useState(readDismissed)

  // The Security section shows the same notice beside the two-step control.
  const onSetupPage = location.pathname === STAFF_MFA_SETUP_PATH
  if (!isAuthenticated || !shouldShowStaffMfaNotice(user) || dismissed || onSetupPage) return null

  const handleClose = () => {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1')
    } catch {
      // ignore storage errors (private mode, etc.)
    }
    setDismissed(true)
  }

  return (
    <Collapse in>
      <Alert
        severity="warning"
        icon={<Security />}
        sx={{ borderRadius: 0, py: 0.5, '& .MuiAlert-action': { alignItems: 'center', pt: 0 } }}
        action={
          <>
            <Button color="inherit" size="small" onClick={() => navigate(STAFF_MFA_SETUP_PATH)}>
              Set up two-step
            </Button>
            <IconButton color="inherit" size="small" aria-label="Dismiss" onClick={handleClose}>
              <Close fontSize="small" />
            </IconButton>
          </>
        }
      >
        {STAFF_MFA_NOTICE}
      </Alert>
    </Collapse>
  )
}
